import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomModal from '../components/CustomModal';
import { closeAutoLogoutWarning, autoLogoutWarningCanceled, logOutForInactivity } from '../actions/login';

const propTypes = {
  intervalDuration: PropTypes.number,
  isOpen: PropTypes.bool,
  logOut: PropTypes.func,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
};

const defaultProps = {
  isOpen: false,
};

export class AutoLogoutWarning extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsElapsed: 0,
      intervalDuration: this.props.intervalDuration ? this.props.intervalDuration : 1000,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen && nextProps.isOpen) {
      this.setState({ secondsElapsed: 0 });
      this.interval = setInterval(() => this.tick(), this.state.intervalDuration);
    }

    if (nextProps.isOpen !== this.props.isOpen && !nextProps.isOpen) {
      clearInterval(this.interval);
    }
  }

  tick() {
    this.setState((prevState) => ({
      secondsElapsed: prevState.secondsElapsed + 1,
    }));

    if (this.state.secondsElapsed >= 60 && this.props.logOut) {
      this.props.logOut();
      clearInterval(this.interval);
    }
  }

  timeLeft() {
    const timeLeft = 60 - this.state.secondsElapsed;

    if (timeLeft > 0) {
      return timeLeft;
    }

    return 0;
  }

  modalBody() {
    return (
      <div>
        <p>Your session will expire in {this.timeLeft()} seconds.</p>
        <p>
          Press <b>Continue</b> to remain logged in or Press <b>Log Off</b> to log off.
        </p>
        <p>If you are logged off, any changes will be lost.</p>
      </div>
    );
  }

  modalContent() {
    return {
      title: 'Auto Logout in Progress',
      body: this.modalBody(),
      confirm: this.props.confirm,
      cancel: this.props.cancel,
      cancelButtonName: 'Log Off',
      confirmButtonName: 'Continue',
    };
  }

  render() {
    return <CustomModal content={this.modalContent()} isOpen={this.props.isOpen} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.login.warnForAutoLogout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    confirm: () => dispatch(closeAutoLogoutWarning()),
    cancel: () => dispatch(autoLogoutWarningCanceled()),
    logOut: () => dispatch(logOutForInactivity()),
  };
};

AutoLogoutWarning.propTypes = propTypes;
AutoLogoutWarning.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(AutoLogoutWarning);
